/* eslint-disable react/prop-types */
import React from 'react';
import { useBTSChatContext } from './BTSChatContext';
import ClassRow from './ClassRow';
import { FaAngleRight, FaAngleDown } from 'react-icons/fa';

const SchoolCard = ({ school }) => {
  const { expandedSchoolCode, setExpandedSchoolCode } = useBTSChatContext();
  
  const isExpanded = expandedSchoolCode === school.schoolCode;
  
  const handleToggle = () => {
    setExpandedSchoolCode(isExpanded ? null : school.schoolCode);
  };

  const formatUnreadCount = (count) => {
    if (!count) return '';
    return count < 10 ? `0${count}` : String(count);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (e) {
      return '';
    }
  };

  return (
    <div className="border border-gray-200 rounded-md overflow-hidden bg-white hover:border-[#E8A020] transition-colors duration-300">
      {/* School Card Header (clickable to expand) */}
      <div
        onClick={handleToggle}
        className="p-3 cursor-pointer select-none flex items-center justify-between hover:bg-gray-50 transition-colors duration-300"
      >
        <div className="flex flex-col gap-0.5">
          <span className="text-xs font-semibold text-[#C8A84B]">
            #{school.schoolCode}
          </span>
          <span className="text-sm font-bold text-gray-800 break-words max-w-[240px] xl:max-w-[280px]">
            {school.schoolName}
          </span>
          <span className="text-xs font-medium text-[#C8A84B]">
            {school.classes ? school.classes.length : 0} Classes · {school.salesRepName || 'No Rep'}
          </span>
          {school.createdDate && (
            <span className="text-[10px] text-gray-500 font-medium">
              Created Date: {formatDate(school.createdDate)}
            </span>
          )}
        </div>

        <div className="flex items-center gap-3">
          {/* Total Unread Count Badge */}
          {school.totalUnreadCount > 0 && (
            <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[rgb(237,28,36)] text-white text-[10px] font-bold">
              {formatUnreadCount(school.totalUnreadCount)}
            </div>
          )}
          
          {/* Chevron */}
          <span className="text-gray-400">
            {isExpanded ? <FaAngleDown size={16} /> : <FaAngleRight size={16} />}
          </span>
        </div>
      </div>

      {/* Expanded Class List */}
      {isExpanded && school.classes && school.classes.length > 0 && (
        <div className="border-t border-gray-100 bg-gray-50 divide-y divide-gray-100">
          {school.classes.map((cls) => (
            <ClassRow
              key={cls.classId}
              classItem={cls}
              schoolName={school.schoolName}
              schoolCode={school.schoolCode}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SchoolCard;
